module.exports = __webpack_public_path__ + "img/27.5acb5457.jpg";